// Copyright (c) 2016 Deere & Company

import Agency, {getDefaultState as getAgencyDefaultState} from './agency';
import t from 'tcomb';

const LawEnforcementDetails = t.struct({
    agency: Agency,
    reportNumber: t.String,
    stolenDate: t.maybe(t.Number)
}, {
    name: 'LawEnforcementDetails',
    strict: true
});

export const getDefaultState = () => new LawEnforcementDetails({
    agency: getAgencyDefaultState(),
    reportNumber: '',
    stolenDate: null
});

export default LawEnforcementDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/law-enforcement-details.js